import axios from '../axios'
import { history } from '../App'
import constants from '../constants'

const errMsg = 'Server is unavailable.'

const login = (email, password) => (dispatch) => {
  axios.post('/admin/auth/login', {
    sLogin: email,
    sPassword: password
  }).then((response) => {
    localStorage.setItem('Token', response.data.Authorization)
    localStorage.setItem('adminData', JSON.stringify(response.data.data))
    dispatch({
      type: constants.LOGIN,
      payload: {
        token: response.data.Authorization,
        data: response.data.data,
        resStatus: true,
        resMessage: response.data.message
      }
    })
  }).catch((error) => {
    dispatch({
      type: constants.LOGIN,
      payload: {
        resStatus: false,
        resMessage: error.response ? error.response.data.message : errMsg
      }
    })
  })
}

const logout = token => (dispatch) => {
  axios.put('/admin/auth/logout', {}, { headers: { Authorization: token } }).then(async (response) => {
    localStorage.removeItem('Token')
    localStorage.removeItem('adminData')
    history.push('/auth/login')
    dispatch({ type: constants.CLEAR_AUTH_PROPS })
    dispatch({ type: constants.CLEAR_ACCOUNT_PROPS })
    dispatch({ type: constants.CLEAR_USER_PROPS })
    dispatch({ type: constants.CLEAR_FEEDBACK_PROPS })
    dispatch({ type: constants.CLEAR_NOTIFICATION_PROPS })

    dispatch({
      type: constants.LOGOUT,
      payload: {
        resStatus: true,
        resMessage: response.data.message
      }
    })
  }).catch((error) => {
    dispatch({
      type: constants.LOGOUT,
      payload: {
        resStatus: false,
        resMessage: error.response ? error.response.data.message : errMsg
      }
    })
  })
}

export { login, logout }
